var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04715 7.59453C7.77172 7.85417 7.39836 8 7.00908 8C6.6198 8 6.24644 7.85417 5.97101 7.59453L0.430044 2.36676C0.154599 2.10667 -9.17877e-05 1.75396 4.08604e-08 1.38622C9.18694e-05 1.01849 0.154959 0.665848 0.430533 0.40588C0.706107 0.145913 1.07981 -8.66303e-05 1.46944 3.85644e-08C1.85907 8.67074e-05 2.2327 0.146252 2.50815 0.406342L7.00908 4.65437L11.51 0.406342C11.7869 0.153666 12.1579 0.0137546 12.5431 0.0167409C12.9283 0.0197273 13.2968 0.165373 13.5693 0.422308C13.8417 0.679244 13.9964 1.02691 13.9999 1.39043C14.0035 1.75395 13.8556 2.10423 13.5881 2.36583L8.04813 7.59546L8.04715 7.59453Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorSelect);
export default __webpack_public_path__ + "static/media/vector_select.a7357343d17425b7c3c4b07b43ba4fa7.svg";
export { ForwardRef as ReactComponent };